import { IFieldDefinitionLogic } from '../../../interfaces/ifield-definition-logic.interface';
import { MetadataFieldDefinitionLogicBase } from './metadata-field-def-logic-base';

export class FormInstanceIdFieldDefinitionLogic extends MetadataFieldDefinitionLogicBase implements IFieldDefinitionLogic {
    // Constructor.
    public constructor() {
        super('formInstanceId');
    }

    public get canParticipateInFlexFieldBehavior(): boolean {
        return true;
    }

    public get isNonFlexFieldButCanParticipateInFlexFieldBehavior(): boolean {
        return true;
    }

    public telerikFilterControlEditorName(): string {
        return 'number';
    }
    public telerikFilterControlComparisonOperators(): string[] {
        return ["neq", "eq", "gt" , "gte" , "lt" , "lte"];        
    }
}
